/* Lichtgrün — endless scroll for the collection grid. Progressive enhancement: hides pagination, appends next pages. */
(function () {
  function init() {
    var grid = document.querySelector('.lg-coll__grid[data-infinite]');
    if (!grid || !('IntersectionObserver' in window)) return;
    var pag = document.querySelector('.lg-coll__pag');
    if (pag) pag.style.display = 'none';

    var loading = false, done = false;
    var sentinel = document.createElement('div');
    sentinel.className = 'lg-coll__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    function finish() { done = true; obs.disconnect(); if (sentinel.parentNode) sentinel.remove(); }

    function loadNext() {
      if (loading || done) return;
      var next = grid.getAttribute('data-next');
      if (!next) { finish(); return; }
      loading = true;
      grid.classList.add('is-loadingmore');
      fetch(next, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ng = doc.querySelector('.lg-coll__grid');
          if (ng && ng.firstElementChild) {
            while (ng.firstElementChild) { grid.appendChild(ng.firstElementChild); }
            grid.setAttribute('data-next', ng.getAttribute('data-next') || '');
          } else {
            grid.setAttribute('data-next', '');
          }
          loading = false;
          grid.classList.remove('is-loadingmore');
          if (!grid.getAttribute('data-next')) { finish(); }
          else { setTimeout(check, 80); }
        })
        .catch(function () { loading = false; grid.classList.remove('is-loadingmore'); });
    }

    function check() {
      if (done) return;
      var r = sentinel.getBoundingClientRect();
      if (r.top < window.innerHeight + 700) loadNext();
    }

    var obs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '700px 0px' });
    obs.observe(sentinel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
